module.exports = __webpack_public_path__ + "static/media/agency.d40bfd5f.svg";